import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AddNewDigitalQuestionsVM, DigitalFormQuestionTypesVM, UpdateDigitalFormSectionVM } from '../../../perform-induction/perform-induction';
import { SafetyInductionService } from '../../../services/safety-induction.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  QuestionTypes: DigitalFormQuestionTypesVM[],
  QuestionId: number,
  CatId: number,
  FormId: number,
  AddQuestion: boolean,
  Title: string,
  Description: string,
  QuestionTypeId: number,
  AddSection: boolean,
  EditSection:boolean,
  SectionId:number
}


@Component({
  selector: 'app-dialog-add-question',
  templateUrl: './dialog-add-question.component.html',
  styleUrls: ['./dialog-add-question.component.scss']
})
export class DialogAddQuestionComponent implements OnInit {

  constructor(
    private _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<DialogAddQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _inductionService: SafetyInductionService,
  ) { }


  AddQuestion: boolean = false;
  Description: string = "";
  Title: string = "";
  QuestionType: number = -1;
  AddSection: boolean
  EditSection:boolean
  SectionId:number

  ngOnInit() {
    this.AddQuestion = this.data.AddQuestion
    if (this.AddQuestion != true) {
      this.Title = this.data.Title
      this.Description = this.data.Description
      this.QuestionType = this.data.QuestionTypeId
      this.AddSection = this.data.AddSection
      this.EditSection = this.data.EditSection
      this.SectionId = this.data.SectionId
    }

  
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmitClick(): void {

    if (this.AddQuestion) {
      console.log("this.Title,this.QuestionType", this.QuestionType, this.Title)
      if (this.Title && this.QuestionType > -1) {
        let req = new AddNewDigitalQuestionsVM();
        req.Title = this.Title;
        req.Desc = this.Description;
        req.QuestionTypeId = this.QuestionType;
        req.CatId = this.data.CatId;
        req.FormId = this.data.FormId;

        this._inductionService.AddNewDigitalQuestions(req).subscribe(res => {


          this.dialogRef.close(true);

        })
      }

    } else if (this.AddSection) {

      let req = new UpdateDigitalFormSectionVM();
      req.SectionName = this.Title;
     // req.SectionId = this.Description;
      req.FormId = this.data.FormId;

      this._inductionService.AddNewDigitalFormSection(req).subscribe(res => {

        this.dialogRef.close(true);

      })
    } else if(this.EditSection){
      

      let req = new UpdateDigitalFormSectionVM();
      req.SectionName = this.Title;
      req.SectionId = this.SectionId;
      req.FormId = this.data.FormId;

      this._inductionService.UpdateDigitalFormSection(req).subscribe(res => {

        this.dialogRef.close(true);

      })
    } else {
      if (this.Title && this.QuestionType > -1) {
        let req = new AddNewDigitalQuestionsVM();
        req.Title = this.Title;
        req.Desc = this.Description;
        req.QuestionTypeId = this.QuestionType;
        req.QId = this.data.QuestionId

        this._inductionService.UpdateDigitalFormQuestion(req).subscribe(res => {

          this.dialogRef.close(true);

        })
      }
    }





  }



}
